import classNames from 'classnames/bind';
import React, { PropsWithChildren } from 'react';
import Button from '../Button';
import Tooltip from '../Tooltip';

import styles from './Tabs.module.scss';

const cx = classNames.bind(styles);

export interface TabData extends PropsWithChildren {
  active?: boolean;
  onClick?: () => void;
  label: string;
  dataTestId?: string;
  tooltipText?: string;
}

interface TabsProps {
  tabs?: TabData[];
  dataTestId?: string;
}

const Tabs = ({ tabs, dataTestId }: TabsProps): React.ReactElement | null => {
  if (!tabs) return null;

  const renderTabButton = (index, onClick, active, children, label, dataTestId) => (
    <Button
      key={`${label}-${index}`}
      onClick={onClick}
      dataTestId={dataTestId}
      className={cx('tab', { 'is-active': active })}
    >
      {children}
      {label}
    </Button>
  );

  return (
    <span data-testid={dataTestId} className={cx('body')}>
      {tabs.map(({ active, onClick, label, children, tooltipText, dataTestId }, i) =>
        tooltipText ? (
          // eslint-disable-next-line react/no-array-index-key
          <Tooltip key={`${label}-${i}-tooltip`} content={tooltipText}>
            {renderTabButton(i, onClick, active, children, label, dataTestId)}
          </Tooltip>
        ) : (
          renderTabButton(i, onClick, active, children, label, dataTestId)
        )
      )}
    </span>
  );
};

export default Tabs;
